import React from "react";

import HeaderTableIdeas from "./HeaderTableIdeas";
import RowsIdeas from "./RowsIdeas";
import "./styles.css";

const IdeasTable = ({
  rows,
  ideasPicked,
  handlePickedIdea,
  handlePickedIdeasAll,
  selectedAll,
  handleSortChange,
  sort,
}) => {
  return (
    <div className="ideas-table">
      <HeaderTableIdeas
        handlePickedIdeasAll={handlePickedIdeasAll}
        selectedAll={selectedAll}
        handleSortChange={handleSortChange}
        sort={sort}
      />

      <RowsIdeas rows={rows} ideasPicked={ideasPicked} handlePickedIdea={handlePickedIdea} />
    </div>
  );
};

export default IdeasTable;
